export function isNullOrUndefined(value: unknown) {
  return value == null;
}
